<template>
  <div class="slide-error">
    <section class="slide-error__section">
      <img class="slide-error__image" :src="icon" />
      <div class="slide-error__text">
        <h3 class="slide-error__title">
          {{ title }}
        </h3>
        <p v-html="text" />
      </div>
    </section>
    <slide-submit-button-wrapper v-slot="{ disabled }" class="slide-error__button-wrapper">
      <hd-button
        v-if="buttonText"
        :disabled="disabled"
        class="slide-error__button"
        modifier="primary"
        type="submit"
      >
        {{ buttonText }}
      </hd-button>
    </slide-submit-button-wrapper>
  </div>
</template>

<script>
import { HdButton } from 'homeday-blocks';
import SlideSubmitButtonWrapper from '@/components/SlideSubmitButtonWrapper.vue';

export default {
  name: 'SlideError',
  components: {
    HdButton,
    SlideSubmitButtonWrapper,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.slide-error {
  display: flex;
  flex-direction: column;

  &__section {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: getShade($quaternary-color, 40);
    padding: $sp-l;
    margin-bottom: $sp-l;

    @include for('tablet') {
      flex-direction: row;
      justify-content: center;
      padding-top: $sp-xl;
      padding-bottom: $sp-xl;
      margin-bottom: $sp-xl;
    }
  }

  &__image {
    width: 140px;
    height: 140px;

    @include for('tablet') {
      margin-right: $sp-m;
    }
  }

  &__text {
    @include for('mobile-only') {
      text-align: center;
    }
  }

  &__title {
    @include font('DS-400');

    margin-bottom: $sp-m;
  }

  &__button {
    @include for('tablet') {
      padding-left: $sp-l;
      padding-right: $sp-l;
    }
  }
  &__button-wrapper {
    margin: auto;
    width: auto;
  }
}
</style>
